// $("#mainProductSldier").slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: false,
//   fade: true,
//   asNavFor: "#previewProductSldier",
//   prevArrow: '<button class="slick-prev"></button>',
//   nextArrow: '<button class="slick-next"></button>',
//   responsive: [
//     {
//       breakpoint: 991,
//       settings: {
//         dots: true,
//         // slidesToShow: 1,
//       },
//     },
//   ],
// });
// $("#previewProductSldier").slick({
//   slidesToShow: 6,
//   asNavFor: "#mainProductSldier",
//   vertical: true,
//   verticalSwiping: true,
//   autoplay: true,
//   autoplaySpeed: 6000,
//   speed: 500,
//   focusOnSelect: true,
//   centerMode: true,
//   centerPadding: "0",

//   infinite: true,

//   prevArrow: '<button class="slick-prev"></button>',
//   nextArrow: '<button class="slick-next"></button>',
//   responsive: [
//     {
//       breakpoint: 991,
//       settings: {
//         settings: "unslick", // Disable slider entirely at 991px or lower

//         // slidesToShow: 1,
//       },
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         settings: "unslick", // Disable slider entirely at 991px or lower

//         // slidesToShow: 1,
//       },
//     },
//   ],
// });

$("#mainProductSldier").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false, // Ensure arrows are disabled
  fade: true,
  asNavFor: "#previewProductSldier",

  responsive: [
    {
      breakpoint: 1025,
      settings: {
        prevArrow: '<button class="slick-prev"></button>',
        nextArrow: '<button class="slick-next"></button>',
        arrows: true,
      },
    },
  ],
});

$("#previewProductSldier").slick({
  slidesToShow: 6,
  asNavFor: "#mainProductSldier",
  vertical: true,
  verticalSwiping: true,
  // autoplay: true,
  autoplaySpeed: 6000,
  speed: 500,
  focusOnSelect: true,
  centerMode: true,
  centerPadding: "0",
  infinite: true,
  prevArrow: '<button class="slick-prev"></button>',
  nextArrow: '<button class="slick-next"></button>',
  responsive: [
    {
      breakpoint: 991,
      // settings: "unslick", // Properly disable the slider for 991px or lower
    },
    {
      breakpoint: 600,
      // settings: "unslick", // Properly disable the slider for 600px or lower
    },
  ],
});

/**
 * Product estimate shipping toggle
 */
var $toggleEstimateShipping = $("#show-estimate-shipping");
var $estimateShipping = $("#product__estimate-shipping");
var $estimateShippingSubmit = $estimateShipping.find('[type="submit"]');
var $estimateShippingLoader = $(".est-shipping__form-loading");
var $estimateShippingMsg = $("#est-shipping__form-message");
var $estimateShippingMsgRate = $(".est-shipping__form-message--rate");
var $estimateShippingMsgDate = $(".est-shipping__form-message--date");

$toggleEstimateShipping.on("click", function (e) {
  e.preventDefault();
  $estimateShipping.slideToggle(150);

  // Toggle container height
  // toggleHeight(160);
});

/**
 * Function to format the shipping message
 */
var formatShippingEstimateMsg = function (price, zipcode, state, quantity) {
  if (0 === price) {
    var price = "Free Shipping!";
  } else {
    var price = "$" + (price / 100).toFixed(2);
  }

  return "Estimated shipping: <strong>" + price + "</strong>";
};

/**
 * Function to format the ga event object
 */
var formatGaShippingEventObject = function (product, quantity, state, zipcode, shipping) {
  var gaEventObject = window.gaCalculateShippingEventObject;
  gaEventObject.eventLabel = product + " - " + quantity + " - " + state + " - " + zipcode;
  gaEventObject.eventValue = shipping;
  return gaEventObject;
};

/**
 * Function to send event data to google analytics
 */
var sendGaShippingEvent = function (product, quantity, state, zipcode, shipping) {
  // if google analytics is defined
  if (typeof ga == "function") {
    ga("send", formatGaShippingEventObject(product, quantity, state, zipcode, shipping));
  }
};

/**
 * Product estimate shipping calculate
 */
$estimateShipping.on("submit", function (e) {
  e.preventDefault();

  // rate request object
  var rateRequestObj = window.rateRequestObj;
  rateRequestObj.rate.destination.province = $('[name="est-shipping__state"]').val();
  rateRequestObj.rate.destination.postal_code = $('[name="est-shipping__zipcode"]').val();
  rateRequestObj.rate.destination.city = $('[name="est-shipping__city"]').val();
  rateRequestObj.rate.destination.address1 = $('[name="est-shipping__address"]').val();
  rateRequestObj.rate.items[0].quantity = $('[name="est-shipping__quantity"]').val();

  // showing the loader
  $estimateShippingLoader.show();
  $estimateShippingLoader.removeClass("hidden");

  // hide the message
  $estimateShippingMsg.hide();

  // disable the form
  $estimateShippingSubmit.attr("disabled", "");

  $.ajax({
    url: "https://website-portal.utopiadeals.com/b2b-carrier/api/calculate-ups-shipping-rates",
    method: "POST",
    contentType: "application/json",
    data: JSON.stringify(rateRequestObj),
    json: true,
    dataType: "json",
    headers: {
      "Content-Type": "application/json",
    },
    success: function (data) {
      // hide loader
      $estimateShippingLoader.hide();
      $estimateShippingLoader.addClass("hidden");

      // enable the submit
      $estimateShippingSubmit.removeAttr("disabled");

      // show the message
      $(".est-shipping__form-message--rate").removeClass("error"), $estimateShippingMsgRate.html(formatShippingEstimateMsg(data.rates[0]["total_price"], rateRequestObj.rate.destination.postal_code, rateRequestObj.rate.destination.province, rateRequestObj.rate.items[0].quantity));
      $estimateShippingMsgDate.html(data.rates[0]["description"]);
      $estimateShippingMsg.show();

      // send the event data to google analytics
      sendGaShippingEvent(rateRequestObj.rate.items[0].sku, rateRequestObj.rate.items[0].quantity, rateRequestObj.rate.destination.province, rateRequestObj.rate.destination.postal_code, data.rates[0]["total_price"] / 100);

      // Toggle container height
      // toggleHeight();
    },
    error: function (err) {
      // hide loader
      $estimateShippingLoader.hide();
      $estimateShippingLoader.addClass("hidden");

      // enable the submit
      $estimateShippingSubmit.removeAttr("disabled");

      // show the message
      $(".est-shipping__form-message--rate").addClass("error"), $estimateShippingMsgRate.html("Couldn't calculate shipping. Please check the details you entered.");
      $estimateShippingMsgDate.html("");
      $estimateShippingMsg.show();

      // send the event data to google analytics
      sendGaShippingEvent(rateRequestObj.rate.items[0].sku, rateRequestObj.rate.items[0].quantity, rateRequestObj.rate.destination.province, rateRequestObj.rate.destination.postal_code, "Error");

      // Toggle container height
      // toggleHeight();

      throw err;
    },
  });
});

/**
 * product video play
 */
var $productVideoThumb = $("[data-product-gallery-video]");
var isVideoPlayed = false;

$productVideoThumb.on("click", function (e) {
  e.preventDefault();

  // get the video id
  var $videoId = $(this).attr("data-product-gallery-video");

  // empty the gallery main image src
  $productGalleryMain.attr("src", "");

  // show the iframe
  $productGalleryMainContainer.prepend('<iframe src="https://www.youtube.com/embed/' + $videoId + '?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');

  // send GA event
  if (!isVideoPlayed) {
    if (typeof ga == "function") {
      ga("send", "event", "UtopiaDeals.com", "Video Play", $('[itemprop="sku"]').attr("content"));
      isVideoPlayed = true;
      console.log("Sent event.");
    } else {
      console.log("GA not defined");
    }
  }
});

/**
 * Lazyload images
 */
$("[data-lazy-load]").lazyload();

/**
 * page contact
 */
$("#page-contact-form__heard").on("change", function () {
  var $this = $(this);
  console.log($this.val());
  if ($this.val() === "amazon") {
    $("[data-amazon-order-number-container]").show();
    // $("[data-amazon-order-number-container]").show().find("input").attr("required", true);
    // $("[data-amazon-upload-container]").show().find("input").attr("required", true);
  } else {
    $("[data-amazon-order-number-container]").hide();
    // $("[data-amazon-order-number-container]").hide().find("input").removeAttr("required");
    // $("[data-amazon-upload-container]").hide().find("input").attr("required", false);
  }
});

$(document).ready(function () {
  // Find the maximum width of the first <b> tag within <li> elements
  var maxWidth = 0;
  $(".product-desc-list li b:first-child").each(function () {
    var currentWidth = $(this).width();
    if (currentWidth > maxWidth) {
      maxWidth = currentWidth;
    }
  });

  // Set the minimum width with a margin of 20 pixels on the first <b> tag within <li> elements
  var minWidth = maxWidth + 25;
  $(".product-desc-list li b:first-child").css("min-width", minWidth);
});

/**
 * About Page Slider
 */
$(".single-item-about").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  prevArrow: '<button class="slick-prev"></button>',
  nextArrow: '<button class="slick-next"></button>',
});

/**
 * About Page Slider
 */
$(".single-item-about").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  prevArrow: '<button class="slick-prev"></button>',
  nextArrow: '<button class="slick-next"></button>',
});
$(".single-item-privacy").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  prevArrow: '<button class="slick-prev"></button>',
  nextArrow: '<button class="slick-next"></button>',
});
